export default __webpack_public_path__ + "static/media/img7.01d1205a.jpeg";